import { configureStore } from "@reduxjs/toolkit";
import themeSlice, {
  initializeTheme,
  detectSystemThemeChange,
} from "./slices/themeSlice";
import authSlice from "./slices/authSlice";

export const store = configureStore({
  reducer: {
    theme: themeSlice,
    auth: authSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: ["auth/login/fulfilled", "auth/checkAuth/fulfilled"],
        // Ignore these field paths in all actions
        ignoredActionPaths: ["meta.arg", "payload.timestamp"],
        // Ignore these paths in the state
        ignoredPaths: ["auth.user.timestamp"],
      },
    }),
});

// Theme management setup
let cleanupThemeDetection;

export const initializeAppTheme = () => {
  // Initialize theme immediately
  store.dispatch(initializeTheme());

  // Set up system theme change detection and store cleanup function
  cleanupThemeDetection = detectSystemThemeChange(store);
};

// Make store available globally for theme detection
if (typeof window !== "undefined") {
  window.store = store;
}

// Cleanup function for app teardown
export const cleanupAppTheme = () => {
  if (cleanupThemeDetection) {
    cleanupThemeDetection();
  }
};
